import angular from 'angular';
import './resource';
import '../app.constants';

const module = angular.module('whyline.resources.organization-information-screen', [
  'whyline.constants',
  'whyline.resources.resource',
]);

const OrganizationInformationScreenFactory = ($http, $timeout, API_URL, Resource) => {
  const _type = 'organization-information-screen?organizationId';

  const _schema = {
    _id: {
      type: String,
    },
    button: {
      label: {
        type: String,
      },
      url: {
        type: String,
      },
    },
    isActive: {
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    messages: {
      kiosk: {
        required: true,
        type: String,
      },
      mobileApp: {
        required: true,
        type: String,
      },
      reception: {
        required: true,
        type: String,
      },
    },
    organizationId: {
      required: true,
      type: String,
    },
    type: {
      type: String,
    },
  };

  // eslint-disable-next-line func-names
  const OrganizationInformationScreen = function(data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });

    this.enable = (isActive, isActiveInPlaces) => {
      const promise = $http.put(
        `${API_URL}organization-information-screen/${this._id}/enable?organizationId`,
        {
          isActive,
          isActiveInPlaces,
        },
      );
      promise.then((response) => {
        const item = response.data;
        $timeout(() => {
          OrganizationInformationScreen.UpdateCache(item._id, item, null);
        });
        return OrganizationInformationScreen.GetOneFromCache('_id', this._id);
      });
      return promise;
    };
  };

  OrganizationInformationScreen.prototype = new Resource(
    _type,
    _schema,
    OrganizationInformationScreen,
  );

  Resource.Extend(_type, OrganizationInformationScreen);

  const validityTime = 60 * 60 * 5000;
  OrganizationInformationScreen.InitCache(validityTime);

  return OrganizationInformationScreen;
};

module.exports = module.factory(
  'OrganizationInformationScreen',
  OrganizationInformationScreenFactory,
);
